const ssVendorHandle = document.querySelector('#vendorHandle');
const brandArray = window.brandData;

let ssFromBrandParam = '';
let ssLabelCode = '';
let ssLabelName = ''
if(ssVendorHandle) {
  ssLabelName = ssVendorHandle.value;
  ssFromBrandParam = `&from_brand=${ssLabelName}&type=${ssLabelName}`;
  if(ssLabelName) {
    for (let i = 0; i < brandArray.length; i++) {
      const element = brandArray[i];
      if(ssLabelName === element.brandHeaderCode) {
        ssLabelCode = element.brandCode;
        break;
      }
    }
  }
}

function checkMatchLabel(code) {
  if(!!ssLabelCode) {
      var ssLabelCodeAry = ssLabelCode.split(',');

      return ssLabelCodeAry.includes(code)
  }
}
